// Third Party Library
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tabs } from "antd";

// Constants Library
import { TEMPLATE } from "../../constants";

// Components Library
import { BtnSubmit, TableList } from "../../components";
import { CreateEmployer } from "./components";
import { TableItems } from "./components/TableEmployer/items";

// Handler Library
import { exportHDLR, tableHDLR } from "../../handlers";

// Services Library
import { TIME, REDUX as REDUX_UTIL } from "../../services/util";

// Redux Actions
import * as REDUX_ACTION from "../../services/redux/actions";

// Styles Library
import styles from "../../pages/index.module.css";

const { reduxStoreWrapper } = REDUX_UTIL;
const { parseExportTime } = TIME;
const { BTN_IMG } = TEMPLATE.BTN;
const { EMPLOYER_SUMMARY_COL } = TEMPLATE.TABLEDATA.EMPLOYER;
const { SELECT_OPTIONS } = TEMPLATE.EMPLOYER;

const EmployerList = (props) => {
  const { col } = props;
  const dispatch = useDispatch();

  const employers = useSelector(reduxStoreWrapper("employer.byID")) || {};
  const company = useSelector(reduxStoreWrapper("company.byID"));

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [tabKey, setTabKey] = useState("all");
  const [pageSize, setPageSize] = useState(10);
  const [employer, setEmployer] = useState([]);
  const [current, setCurrent] = useState(1); 
  const [paginatedData, setPaginatedData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  // Filtered Data
  const statusText = {
    all: "all",
    active: 1,
    suspended: 2,
    terminated: 0,
  };

  useEffect(() => {
    dispatch(REDUX_ACTION.v1_employer.get_all_employer_request());
    // return () => {};
  }, [dispatch]);

  useEffect(() => {
    const updatedEmployer = Object.values(employers).map((t) => {
      const coid = t.coid?.trim();
      const cp = company[coid];
      return {
        ...t,
        key: t?.memid,
        status: t?.status ?? 1,
        company_name: cp?.name,
      };
    });
    setEmployer(updatedEmployer);
  }, [employers, company]);

  useEffect(() => {
    if (employer.length > 0)
      setFilteredData(tableHDLR.dataTableSorting(employer));
  }, [employer]);

  const handleTab = (key) => {
    setTabKey(key);
    setCurrent(1);
  };

  // Pagination
  const filteredDataCount = tableHDLR.dataCount(statusText, filteredData);

  useEffect(() => {
    if(filteredData.length){
    const startIndex = (current - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const newData = tableHDLR.datasourceFilter(filteredData, tabKey) ?? []
    const slicedData = newData.slice(startIndex, endIndex);

      setPaginatedData(slicedData);
    }
  }, [current, pageSize, filteredData, tabKey]);

  const handlePageChange = (page) => {
    const sorted = tableHDLR.dataTableSorting(page);
    setPaginatedData(sorted);
  };

  // Exports Data
  const exportData = selectedRow.length > 0 ? selectedRow : filteredData;
  const template = EMPLOYER_SUMMARY_COL({
    exportState: true,
  });

  const exportButton = (
    <BtnSubmit
      display="inline-block"
      text="Export"
      bgColor="transparent"
      color="#4CAF50"
      padding="9px 18px"
      onClick={() =>
        exportHDLR.exportWithTemplate({
          data: exportData,
          filename: `EmployerSummary_${parseExportTime()}`,
          template: template,
        })
      }
      showIcon={true}
      icon={BTN_IMG.EXPORT}
      icon_alt={"export"}
    />
  );

  return (
    <>
      <div
        className={styles.container}
        style={{ width: col ? "80vw" : "73vw" }}
      >
        <TableList.FilterData
          isModalOpen={isModalOpen}
          setIsModalOpen={() => setIsModalOpen(false)}
          selectOptions={SELECT_OPTIONS}
          filteredData={tableHDLR.datasourceFilter(employer, tabKey)}
          setFilteredData={setFilteredData}
          tabKey={tabKey}
          statusText={statusText}
        />
        <CreateEmployer
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          pageSize={pageSize}
          setPageSize={setPageSize}
          tabKey={tabKey}
          current={current}
          setCurrent={setCurrent}
          handlePaginatedDataChange={handlePageChange}
          filteredDataCount={filteredDataCount}
          data={filteredData}
        />
        <div style={{ marginTop: "3.5em" }}>
          <Tabs
            tabBarExtraContent={exportButton}
            onTabClick={handleTab}
            items={TableItems(
              filteredDataCount,
              employer,
              filteredData,
              paginatedData,
              tabKey,
              setFilteredData,
              selectedRow,
              setSelectedRow
            )}
          />
        </div>
      </div>
    </>
  );
};

export default EmployerList;
